import { render } from "./HeroiconsSolidHome.vue?vue&type=template&id=d1d7c13e"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidHome.vue"]])

export default __exports__